import { Box, styled, Tab } from "@mui/material";

export const BookingsScreenContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "stretch",
  margin: "40px auto",
  flexDirection: "column",
  maxWidth: "var(--max-screen-width)",
  padding: theme.spacing(0, 2),
  width: "100%",
  boxSizing: "border-box",
}));

export const BookingsScreenHeader = styled("h5")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.h5.fontSize,
  fontStyle: "normal",
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: "40px",
  letterSpacing: "-0.72px",
  textAlign: "center",
}));

export const BookingScreenTableViewContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "0.75rem",
  overflow: "auto",
});

export const TableFilterRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(3),
  marginTop: theme.spacing(3),
  position: "relative",
  flexWrap: "wrap",
}));

export const BookingsScreenContainerWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const BookingsScreenFooterWrapper = styled(Box)({
  marginTop: "auto",
});

export const StyledBookingTab = styled(Tab)(({ theme }) => ({
  flexDirection: "row",
  padding: "16px",

  "&, p": {
    textTransform: "none",
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.disabled,
    fontSize: "24px",
    lineHeight: "28px",
    whiteSpace: "nowrap",
  },

  "&.Mui-selected": {
    "&,  p": {
      color: theme.palette.text.primary,
    },
  },

  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    lineHeight: "20px",
  },
}));
